import React from "react";
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";

const StoreOpsScreen = () => {
  return <main>StoreOpsScreen</main>;
};

export default withProtectedRoute(StoreOpsScreen);
